export enum NotificationsActionColor {
  Warning = "#FF9A5C",
  Primary = "#5CD8FF",
  Success = "#5fff69",
  Danger = "#D73434",
}
